import { createRouter, createWebHistory } from 'vue-router'
import Comics from "../components/Comics.vue";
import Comic from "../components/Comic.vue";
import Follows from "../components/Follows.vue";
import Read from "../components/Read.vue";
import NotFound from "../components/NotFound.vue";

export const router = createRouter({
    history: createWebHistory(BASE_URL.split('/').slice(3).filter(Boolean).join('/')),
    routes: [
        {path: '/public/*', redirect: '/*'},
        {path: '/', component: Comics, name: 'Dernières sorties'},
        {path: '/comics', component: Comics, name: 'Tous les mangas'},
        {path: '/recommended', component: Comics, name: 'Recommandés'},
        {path: '/comics/:slug', component: Comic},
        {path: '/targets/:target', component: Comics},
        {path: '/genres/:genre', component: Comics},
        {path: '/suivis', component: Follows, name: 'Mes suivis'},
        {path: '/read/:slug/:lang/:pathMatch(vol/\\d+|ch/\\d+|sub/\\d+)*', component: Read},
        {path: '/:pathMatch(.*)*', component: NotFound},
    ]
})
